import React, { Component } from "react";
import { Image } from "../../rpc/admin/image_pb";
import { getInstance, Instance } from "../../helpers/instance";

export class ImagePair {
    original?: Image;
    thumbnail?: Image;
    alt: string = '';
}

class ProductImageProps {
    images: ImagePair[] = [];
}

class ProductImageState {
    selectedIndex: number = -1;
}

class ProductImage extends Component<ProductImageProps, ProductImageState> {

    constructor(props: ProductImageProps) {
        super(props);
        this.state = {
            selectedIndex: 0,
        };
    }

    static imageUrl(path: string): string {
        if (getInstance() === Instance.InstanceLocal) {
            return 'https://dashboard.hawkamerican.dev/' + path;
        }
        return '/' + path;
    }

    onChangePage = (index: number) => {
        this.setState({
            selectedIndex: index,
        });
    }

    render() {
        const images = this.props.images;
        let thumbnail = 0;

        return (
            <div className="product-image">
                {images.length > 0 &&
                    <figure className="image">
                        <img src={ProductImage.imageUrl(images[this.state.selectedIndex]!.original!.getPath())}
                            className="product-img"
                            width={images[this.state.selectedIndex].original!.getWidth()}
                            height={images[this.state.selectedIndex].original!.getHeight()}
                            alt={images[this.state.selectedIndex].alt} />
                    </figure>
                }
                <div className="product-image-thumbnails">
                    {
                        images.map((image) => {
                            const thumbnailIndex = thumbnail++;
                            return <figure className="image is-64x64" key={image.thumbnail!.getPath()}>
                                <img src={ProductImage.imageUrl(image.thumbnail!.getPath())}
                                    width="64"
                                    height="64"
                                    alt=""
                                    onClick={() => this.onChangePage(thumbnailIndex)} />
                            </figure>;
                        })
                    }
                </div>
            </div>
        );
    }
}

export default ProductImage;